import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CoreService } from '../core/core.service';

import { map, filter, scan } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from 'src/app/models/user';
import { Roles } from 'src/app/models/role';
import { RightsTemplate } from 'src/app/models/rightsTemplate';
import { ObjectHelper } from 'src/app/models/objectHelper';
import { UserRole } from 'src/app/models/userRoles';
import { UserRights } from 'src/app/models/userRights';
import { pgiAuthors } from 'src/app/models/authors';
// import 'rxjs/add/operator/map';
// import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class UserService implements OnInit {
  private userRoles: Set<string>;
  ngOnInit() {
  }

constructor(private coreService: CoreService, private http: HttpClient, private router: Router, private activatedRoute: ActivatedRoute) { }

  logout() {
    localStorage.removeItem(this.coreService.tokenName);
    this.router.navigateByUrl('/login');
  }

  login(username, password) {
    const url = this.coreService.appRoot + '/' + this.coreService.appToken;
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set('grant_type', 'password');
    urlSearchParams.set('UserName', username);
    urlSearchParams.set('Password', password);
    const body = urlSearchParams.toString();
    console.log(url);
    // const options = { headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }) };
    const headers = new HttpHeaders({'No-Auth': 'True'});
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    return this.http.post(url, body, {headers: headers})
    .pipe(
      map(user => {
          if (user) {
            console.log(user);
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem(this.coreService.tokenName, JSON.stringify(user));
            localStorage.setItem('userName', username);
        }
        return user;
    }));
  }

  getUsers(): Observable<User[]> {
    return  this.http.get<User[]>(this.coreService.appRoot + '/api/users');

  }

  getUserClaims(): Observable<User> {
    return  this.http.get<User>(this.coreService.appRoot + '/api/user');
  }
  getUserClaimsRole(): Observable<User> {
    return  this.http.get<User>(this.coreService.appRoot + '/api/role');
  }
  getRoles(): Observable<Roles[]> {
    return this.http.get<Roles[]>(this.coreService.appRoot + '/api/roles');
  }

  getRightsTemplate(): Observable<RightsTemplate[]> {
    return this.http.get<RightsTemplate[]>(this.coreService.appRoot + '/api/rights');
  }

  save(user, role, rights, author): Observable<ObjectHelper>  {
    const _ObjectHelper = { user: user, rola: role, rights: rights, author: author };
    return this.http.post<ObjectHelper>(this.coreService.appRoot + '/api/addUser' , _ObjectHelper);
  }

  changePass(oldPass, newPass)  {
    const data = { oldPass: oldPass, newPass: newPass };
    return this.http.post(this.coreService.appRoot + '/api/changePass' , data);
  }

  changePassword(newPass, userId)  {
    const data = { newPass: newPass, userId: userId };
    return this.http.post(this.coreService.appRoot + '/api/changePassword' , data);
  }

  getUserRole(id): Observable<UserRole[]> {
    return this.http.get<UserRole[]>(this.coreService.appRoot + '/api/role/' + id);
  }

  getUserRights(id): Observable<UserRights[]> {
    return this.http.get<UserRights[]>(this.coreService.appRoot + '/api/rights/' + id);
  }

  updateUser(user): Observable<User> {
    return this.http.put<User>(this.coreService.appRoot + '/api/updateUser' ,  user);
  }

  updateUserAuthor(author): Observable<string> {
    return this.http.put<string>(this.coreService.appRoot + '/api/changeAuthor' ,  author);
  }

  deactivationAuthor(author): Observable<string> {
    return this.http.put<string>(this.coreService.appRoot + '/api/deactivationAuthor' ,  author);
  }

  changeRole(roleId, userId)  {
    const data = { roleId: roleId, userId: userId };
    return this.http.post(this.coreService.appRoot + '/api/changeRoles' , data);
  }
  changeRight(rights)  {
    return this.http.post(this.coreService.appRoot + '/api/changeRights' , rights);
  }
}
